/*-
 * ========================LICENSE_START=================================
 * TeamApps
 * ---
 * Copyright (C) 2014 - 2026 TeamApps.org
 * ---
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * 
 *      http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =========================LICENSE_END==================================
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 */
export const typescriptDeclarationFixConstant = 1;

import {UiCommand} from "./UiCommand";
import {UiEvent} from "./UiEvent";
import {UiQuery} from "./UiQuery";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiComponentConfig} from "./UiComponentConfig";
import {UiClientObjectConfig} from "./UiClientObjectConfig";
import {UiComponentCommandHandler} from "./UiComponentConfig";


export interface UiToolButtonConfig extends UiComponentConfig {
	_type?: string;
	icon: string;
	iconSize?: number;
	caption?: string;
	popoverText: string;
	grayOutIfNotHovered?: boolean;
	title?: string;
	minDropDownWidth?: number;
	minDropDownHeight?: number;
	openDropDownIfNotSet?: boolean;
	dropDownComponent?: unknown
}

export function createUiToolButtonConfig(icon: string, popoverText: string, nonRequiredProperties?: {id?: string, debuggingId?: string, visible?: boolean, stylesBySelector?: {[name: string]: {[name: string]: string}}, classNamesBySelector?: {[name: string]: {[name: string]: boolean}}, attributesBySelector?: {[name: string]: {[name: string]: string}}, iconSize?: number, caption?: string, grayOutIfNotHovered?: boolean, title?: string, minDropDownWidth?: number, minDropDownHeight?: number, openDropDownIfNotSet?: boolean, dropDownComponent?: unknown}): UiToolButtonConfig {
	return {
		_type: "UiToolButton",
		icon, popoverText,
		...(nonRequiredProperties||{})
	};
}

export interface UiToolButtonCommandHandler extends UiComponentCommandHandler {
	setIcon(icon: string): any;
	setIconSize(iconSize: number): any;
	setCaption(caption: string): any;
	setTitle(title: string): any;
	setGrayOutIfNotHovered(grayOutIfNotHovered: boolean): any;
	setDropDownSize(minDropDownWidth: number, minDropDownHeight: number): any;
	setOpenDropDownIfNotSet(openDropDownIfNotSet: boolean): any;
	setDropDownComponent(dropDownComponent: unknown): any;
	closeDropDown(): any;
}

export interface UiToolButtonEventSource {
	onClicked: TeamAppsEvent<UiToolButton_ClickedEvent>;
	onDropDownOpened: TeamAppsEvent<UiToolButton_DropDownOpenedEvent>;
}

export interface UiToolButton_ClickedEvent extends UiEvent {
}

export interface UiToolButton_DropDownOpenedEvent extends UiEvent {
}

